"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var HeaderApp_1 = __importDefault(require("../../applications/components/HeaderApp"));
var buffs_1 = __importDefault(require("../../applications/components/service-landings/buffs"));
var ssr_1 = require("../../applications/utils/ssr");
if ((0, ssr_1.componentExistsOnPage)('HeaderApp')) {
    var props_1 = (0, ssr_1.getComponentProps)('HeaderApp');
    react_dom_1.default.hydrate(react_1.default.createElement(HeaderApp_1.default, __assign({}, props_1)), (0, ssr_1.getRootElement)('HeaderApp'));
}
var props = (0, ssr_1.getComponentProps)('service-landings/buffs');
react_dom_1.default.hydrate(react_1.default.createElement(buffs_1.default, __assign({}, props)), (0, ssr_1.getRootElement)('service-landings/buffs'));
